<template>
    <div class="body d-flex py-lg-3 py-md-2">
        <div class="container-xxl">
            <div class="row g-3">
                <!-- Left Column with Tabs -->
                <div class="col-xl-8 col-lg-7 col-md-12 rightborderSec">
                    <!-- Entity header (redesign) -->
                    <div class="wx-hero wx-hero-light" v-if="subTaskViewData">
                        <div class="wx-crumbs">
                            <router-link :to="{ path: 'project', query: { id: subTaskViewData.project?.id } }"><span class="wx-lv p">P</span>{{ subTaskViewData.project?.code }}</router-link>
                            <span class="wx-sep">›</span>
                            <router-link :to="{ path: 'task', query: { id: subTaskViewData.task?.id } }"><span class="wx-lv t">T</span>{{ subTaskViewData.task?.title }}</router-link>
                            <span class="wx-sep">›</span>
                            <span class="wx-crumb-cur"><span class="wx-lv s">S</span>Subtask</span>
                        </div>
                        <div class="wx-hero-row">
                            <div class="wx-hero-main">
                                <h1 class="wx-hero-title">{{ subTaskViewData.info?.title }}</h1>
                                <div class="wx-hero-meta">
                                <div class="status-dropdown wx-hero-status">
                                    <button class="status-button justify-content-center" v-if="subTaskViewData"
                                        :style="getStatusStyle(subTaskViewData.status?.id)">
                                        <i :class="getStatusIcon(subTaskViewData.status?.id)"
                                            v-if="canEditSubtask(subTaskViewData) || canEditAllSubtasks || superUser"></i>
                                        {{ getCurrentStatus(subTaskViewData.status?.id) }}
                                        <i class="fa fa-caret-down"
                                            v-if="canEditSubtask(subTaskViewData) || canEditAllSubtasks || superUser"></i>
                                    </button>

                                    <!-- Dropdown Content (Visible on Hover) -->
                                    <div class="status-dropdown-content"
                                        v-if="canEditSubtask(subTaskViewData) || canEditAllSubtasks || superUser">
                                        <button v-for="status in statuses" :key="status.id"
                                            @click="selectStatus(subTaskViewData.info?.id, status.id)"
                                            :style="getStatusStyle(status.id)"
                                            :class="{ 'active-status': subTaskViewData?.value?.status.id === status.id }">
                                            <i :class="status.icon"></i>
                                            {{ status.description }}
                                        </button>
                                    </div>
                                </div>

                                    <span class="wx-chip wx-chip-late" v-if="daysLeft(subTaskViewData.info?.endDate_formatted) !== null && daysLeft(subTaskViewData.info?.endDate_formatted) < 0 && subTaskViewData.status?.id != 3">Εκπρόθεσμο</span>
                                    <span class="wx-chip" v-if="subTaskViewData.info?.endDate_formatted">Λήξη {{ subTaskViewData.info.endDate_formatted }}</span>
                                    <span class="wx-chip" v-if="subTaskViewData.manager">Manager · {{ subTaskViewData.manager.username }}</span>
                                </div>
                            </div>
                            <div class="wx-hero-team">
                                <template v-for="user in subTaskViewData.assigned" :key="user.id">
                                    <img v-if="user?.avatar_file_name" :src="`/storage/avatars/${user.avatar_file_name}`" :title="user.username" class="wx-av" />
                                    <span v-else class="wx-av" :title="user.username">{{ initials(user.username) }}</span>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="wx-tabrow">
                    <!-- Tabs -->
                    <ul class="nav nav-tabs mb-3 p-0 gap-xl-3 gap-2 fs-6 justifyContentbetmob" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: activeTab === 'info' }"
                                @click.prevent="setActiveTab('info')" href="#">Info</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: activeTab === 'managerBrief' }"
                                @click.prevent="setActiveTab('managerBrief')" href="#">Manager's Brief</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: activeTab === 'subTaskChat' }"
                                @click.prevent="setActiveTab('subTaskChat')" href="#">SubTask Chat</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: activeTab === 'files' }"
                                @click.prevent="setActiveTab('files')" href="#">Files</a>
                        </li>
                    </ul>
                        <div class="wx-tab-actions">
                            <div class="status-button-wrapper" v-if="subTaskViewData">
                                <!-- Edit Button Info-->
                                <button class="btn btn-dark p-1"
                                    v-if="!isEditingInfo && activeTab === 'info' && (superUser || canEditAllSubtasks || canEditSubtask(subTaskViewData))"
                                    @click="editSubTask">
                                    <i class="wx-ic wx-ic-edit" title="Edit"></i>
                                </button>

                                <!-- Save and Cancel Buttons -->
                                <div v-if="isEditingInfo && activeTab === 'info'" class="editing-actions">
                                    <!-- Save Button -->
                                    <button class="btn btn-secondary mb-3 p-1" @click="saveInfo">
                                        <i class="wx-ic wx-ic-check" title="Save"></i>
                                    </button>

                                    <!-- Cancel Button -->
                                    <button class="btn btn-danger mt-2 p-1" @click="cancelEditing">
                                        <i class="wx-ic wx-ic-x" title="Cancel"></i>
                                    </button>
                                </div>


                                <!-- Edit Button Manager-->
                                <button class="btn btn-dark p-1"
                                    v-if="!isEditingManagersBrief && activeTab === 'managerBrief' && (subTaskViewData.info.managerId == currentUserInfo?.id || superUser || canEditAllSubtasks)"
                                    @click="editSubTaskManager">
                                    <i class="wx-ic wx-ic-edit" title="Edit"></i>
                                </button>

                                <!-- Save and Cancel Buttons -->
                                <div v-if="isEditingManagersBrief && activeTab === 'managerBrief' && (subTaskViewData.info.managerId == currentUserInfo?.id || superUser || canEditAllSubtasks)"
                                    class="editing-actions">
                                    <!-- Save Button -->
                                    <button class="btn btn-secondary mb-3 p-1" @click="saveManager">
                                        <i class="wx-ic wx-ic-check" title="Save"></i>
                                    </button>

                                    <!-- Cancel Button -->
                                    <button class="btn btn-danger mt-2 p-1" @click="cancelEditingManager">
                                        <i class="wx-ic wx-ic-x" title="Cancel"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Tab Content -->
                    <div class="tab-content pb-5">
                        <!-- Info Tab -->
                        <div v-if="activeTab === 'info'" class="tab-pane fade show active">
                            <div class="card">
                                <div class="card-body" v-if="!isEditingInfo">
                                    <div v-html="subTaskViewData.info?.body" v-if="subTaskViewData" v-target-blank>
                                    </div>
                                </div>
                                <div class="card-body" v-if="isEditingInfo">
                                    <div class="mb-3" v-if="subTaskViewData">
                                        <Editor api-key="no-api-key" :init="tinymceInit"
                                            v-model="subTaskViewData.info.body"></Editor>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="activeTab === 'files'" class="tab-pane fade show active">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex" v-if="!subTaskViewData?.value?.info?.shared_link"><button
                                            style="color: var(--secondary-color);"
                                            @click="createFolder(subTaskViewData?.value?.info?.id)"
                                            class="btn btn-dark">Create folder</button></div>
                                    <iframe :src="subTaskViewData?.value?.info?.shared_link"
                                        style="width: 100%; height: 500px;"></iframe>
                                </div>
                            </div>
                        </div>

                        <!-- Manager's Brief Tab -->
                        <div v-if="activeTab === 'managerBrief'" class="tab-pane fade show active">
                            <div class="card">
                                <div class="card-body" v-if="!isEditingManagersBrief">
                                    <div v-html="subTaskViewData.info?.manager_brief" v-if="subTaskViewData"
                                        v-target-blank></div>
                                </div>
                                <div class="card-body" v-if="isEditingManagersBrief">
                                    <div class="mb-3" v-if="subTaskViewData">
                                        <Editor api-key="no-api-key" :init="tinymceInit"
                                            v-model="subTaskViewData.info.manager_brief"></Editor>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- SubTask Chat Tab -->
                        <div v-if="activeTab === 'subTaskChat'" class="tab-pane fade show active">
                            <div class="card">
                                <div class="card-body">
                                    <ul ref="chatHistory" class="chat-history list-unstyled">
                                        <li class="mb-3 d-flex" v-if="subTaskViewData && subTaskViewData.comments"
                                            v-for="comment in subTaskViewData.comments" :key="comment.id" :class="{
                            'justify-content-end': comment.author?.id == currentUserId,
                            'justify-content-start': comment.author?.id != currentUserId
                        }">
                                            <div style="width:50%;">
                                                <span class="text-muted small d-flex align-items-center" :class="{
                                'justify-content-end': comment.author?.id == currentUserId,
                                'justify-content-start': comment.author?.id != currentUserId
                            }">
                                                    <img v-if="comment.author?.avatar_file_name"
                                                        :src="`/storage/avatars/${comment.author?.avatar_file_name}`"
                                                        width="25" class="me-2" style="width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;" :title="comment.author.username" />
                                                    <h6 v-else class="fw-bolder">{{ comment.author.username }}</h6>
                                                </span>
                                                <div class="chat-message p-2 mt-1 rounded"
                                                    v-html="parseLinks(comment.info?.comment)">
                                                </div>
                                                <span class="text-muted small">
                                                    <i class="icofont icofont-date"></i><i class="wx-ic wx-ic-calendar" title="Edit"></i>{{ comment.info.created_at
                                                    }}
                                                </span>
                                                <div class="mt-1 d-flex align-items-center justify-content-end"
                                                    v-if="comment.read_by_users && comment.read_by_users.length">
                                                    <span class="me-2 text-muted small">Διαβάστηκε από:</span>
                                                    <div class="d-flex align-items-center avatar-stack">
                                                        <div v-for="(user, index) in comment.read_by_users"
                                                            :key="user.id" :title="user.username" class="avatar-wrapper"
                                                            :style="{ left: `${index * 16}px` }">
                                                            <img v-if="user.avatar_file_name"
                                                                :src="`/storage/avatars/${user.avatar_file_name}`"
                                                                :alt="user.username"
                                                                class="rounded-circle border avatar-img" />
                                                            <span v-else class="avatar-text">{{
                                                                user.username.charAt(0).toUpperCase() }}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </li>
                                    </ul>
                                    <div class="d-flex align-items-end gap-2">
                                        <textarea id="commentTextarea" class="form-control position-relative"
                                            placeholder="Αποστολή Μηνύματος" v-model="newComment"
                                            @input="filterUsernames" @keydown.enter.prevent="submitComment"></textarea>

                                        <!-- Autocomplete Dropdown -->
                                        <div v-if="showAutocomplete" class="autocomplete-dropdown" :style="{
                                            top: `${dropdownTop}px`,
                                            left: `${dropdownLeft}px`,
                                            width: `${dropdownWidth}px`
                                        }">
                                            <ul class="list-unstyled m-0 p-2">
                                                <li v-for="user in filteredUsernames" :key="user.id"
                                                    @click="selectUsername(user.username)" class="autocomplete-item">
                                                    {{ user.username }}
                                                </li>
                                            </ul>
                                        </div>
                                        <button @click.prevent="submitComment" class="btn sendComment mt-2">
                                            <i class="fa fa-paper-plane"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Right Column with SubTask Details -->
                <div class="col-xl-4 col-lg-5 col-md-12" v-if="activeTab != 'subTasks' && subTaskViewData"
                    style="position: relative;">
                    <!-- Edit Button -->

                    <!-- Card Content -->
                    <div class="card wx-details">
                        <div class="card-body">
                            <button class="btn btn-dark p-1 belowEditbtn"
                                v-if="!isEditingGeneral && (superUser || canEditAllSubtasks || canEditSubtask(subTaskViewData))"
                                @click="editSubTaskGeneral" style="position: absolute; top: 25px; right: 10px;">
                                <i class="wx-ic wx-ic-edit" title="Edit"></i>
                            </button>

                            <!-- Save Button -->
                            <button class="btn btn-secondary mb-0 mb-xl-3 p-1" @click="saveGeneral"
                                v-if="isEditingGeneral" style="position: absolute; top: 25px; right: 10px;">

                                <i class="wx-ic wx-ic-check" title="Save"></i>
                            </button>

                            <!-- Cancel Button -->
                            <button class="btn btn-danger mt-2 p-1" @click="cancelEditingGeneral"
                                v-if="isEditingGeneral" style="position: absolute; top: 65px; right: 10px;">

                                <i class="wx-ic wx-ic-x" title="Cancel"></i>
                            </button>

                            <div class="row px-xl-4 px-1 gap-3" v-if="!isEditingGeneral">
                                <div class="d-flex flex-column-desk">
                                    <div class="col-6 col-xl-12 fs-6 mb-xl1 mb-0 p-0 dateprojectdiv px-0"><i class="wx-ic wx-ic-calendar me-1" title="Edit"></i>
                                        <span>Start Date:<strong> {{subTaskViewData.info.startDate_formatted
                                                }}</strong></span>
                                    </div>
                                    <div class="col-6 col-xl-12 fs-6 p-0 dateprojectdiv">
                                        <i class="wx-ic wx-ic-calendar me-1" title="Edit"></i>
                                        <span>End Date:<strong> {{subTaskViewData.info.endDate_formatted
                                                }}</strong></span>
                                    </div>
                                </div>

                                <br /><br />
                                <div class="col-12 gap-2 align-items-center mb-1" style="display: inline-flex;">
                                    <strong>Creator:</strong> <img v-if="subTaskViewData?.creator?.avatar_file_name"
                                        :src="`/storage/avatars/${subTaskViewData?.creator?.avatar_file_name}`"
                                        width="35" :title="subTaskViewData.creator.username"
                                        class="managerProfIcon" /><span v-else class="avatar-text2"
                                        :title="subTaskViewData.creator.username"> {{
                                        subTaskViewData.creator.username.charAt(0).toUpperCase() }}</span>
                                </div>
                                <div class="col-12 gap-2 align-items-center mb-1" style="display: inline-flex;">
                                    <strong>Manager:</strong> <img v-if="subTaskViewData?.manager?.avatar_file_name"
                                        :src="`/storage/avatars/${subTaskViewData?.manager?.avatar_file_name}`"
                                        width="35" :title="subTaskViewData.manager.username" class="managerProfIcon" />
                                    <span v-else class="avatar-text2" :title="subTaskViewData.manager.username"> {{
                                        subTaskViewData.manager.username.charAt(0).toUpperCase() }}</span>
                                </div>
                                <div class="col-12 gap-2 d-flex align-items-center mb-1" style="display: inline-flex;">
                                    <div class="col-12 gap-2 d-flex align-items-center flex-wrap"><strong>Assigned
                                            Users:</strong>
                                        <div v-for="user in subTaskViewData.assigned" :key="user.id"
                                            style="display: inline-flex; align-items: center;">
                                            <img v-if="(user?.avatar_file_name && user?.active === 1)"
                                                :src="`/storage/avatars/${user.avatar_file_name}`" width="25"
                                                :title="user.username" class="managerProfIcon" /><span
                                                v-if="!user?.avatar_file_name && user?.active === 1"
                                                class="avatar-text2" :title="user.username"> {{
                                                user.username.charAt(0).toUpperCase()
                                                }}</span>

                                        </div>
                                    </div>
                                </div>
                            </div>



                            <!-- <div class="row" v-if="isEditingGeneral">
                                <div class="col-8 d-flex align-items-center mb-3">
                                    <strong class="me-2" style="width: 150px; text-align: right;">Start Date:</strong>
                                    <input type="date" class="form-control flex-grow-1"
                                        v-model="subTaskData.startDate" />
                                </div>
                                <div class="col-8 d-flex align-items-center mb-3">
                                    <strong class="me-2" style="width: 150px; text-align: right;">End Date:</strong>
                                    <input type="date" class="form-control flex-grow-1" v-model="subTaskData.endDate" />
                                </div> <br /><br />

                                <div class="col-8 d-flex align-items-center mb-3"
                                    v-if="superUser || canEditSubTaskCreator">
                                    <strong class="me-2" style="width: 150px; text-align: right;">Creator:</strong>
                                    <Select2 :options="allData.users" v-model="subTaskData.createdBy"
                                        :settings="select2SettingsProject" class="flex-grow-1" />
                                </div>
                                <div class="col-8 d-flex align-items-center mb-3">
                                    <strong class="me-2" style="width: 150px; text-align: right;">Manager:</strong>
                                    <Select2 ref="managerSelectSubTask" :options="filteredUsersForManagerSubTask"
                                        v-model="subTaskData.managerId" :settings="select2SettingsSubTask"
                                        class="flex-grow-1" />
                                </div>
                                <div class="col-8 d-flex align-items-center mb-3">
                                    <strong class="me-2" style="width: 150px; text-align: right;">Assigned
                                        Users:</strong>
                                    <Select2 ref="assignedUsersSelectSubTask" :options="filteredUsersForAssignedSubTask"
                                        v-model="subTaskData.assignedUsers"
                                        :settings="{ ...select2SettingsSubTask, multiple: true }" class="flex-grow-1" />
                                </div>
                            </div> -->

                            <div class="row" v-if="isEditingGeneral" style="max-width: 800px; margin: auto;">
                                <!-- Start Date -->
                                <div class="col-12 row mb-3">
                                    <div class="col-md-3 d-flex align-items-center">
                                        <strong>Start Date:</strong>
                                    </div>
                                    <div class="col-md-8">
                                        <input type="date" class="form-control" v-model="subTaskData.startDate" />
                                    </div>
                                </div>

                                <!-- End Date -->
                                <div class="col-12 row mb-3">
                                    <div class="col-md-3 d-flex align-items-center">
                                        <strong>End Date:</strong>
                                    </div>
                                    <div class="col-md-8">
                                        <input type="date" class="form-control" v-model="subTaskData.endDate" />
                                    </div>
                                </div>

                                <!-- Creator (conditionally shown) -->
                                <div class="col-12 row mb-3" v-if="superUser || canEditSubTaskCreator">
                                    <div class="col-md-3 d-flex  align-items-center">
                                        <strong>Creator:</strong>
                                    </div>
                                    <div class="col-md-8">
                                        <Select2 :options="allData.users" v-model="subTaskData.createdBy"
                                            :settings="select2SettingsProject" class="form-control" />
                                    </div>
                                </div>

                                <!-- Manager -->
                                <div class="col-12 row mb-3">
                                    <div class="col-md-3 d-flex  align-items-center">
                                        <strong>Manager:</strong>
                                    </div>
                                    <div class="col-md-8">
                                        <Select2 ref="managerSelectSubTask" :options="filteredUsersForManagerSubTask"
                                            v-model="subTaskData.managerId" :settings="select2SettingsSubTask"
                                            class="form-control" />
                                    </div>
                                </div>

                                <!-- Assigned Users -->
                                <div class="col-12 row mb-3">
                                    <div class="col-md-3 d-flex align-items-center">
                                        <strong>Assigned Users:</strong>
                                    </div>
                                    <div class="col-md-8">
                                        <Select2 ref="assignedUsersSelectSubTask"
                                            :options="filteredUsersForAssignedSubTask"
                                            v-model="subTaskData.assignedUsers"
                                            :settings="{ ...select2SettingsSubTask, multiple: true }"
                                            class="form-control" />
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                </div>


                <!-- Right Column with SubTask Details -->
                <div class="col-xl-4 col-lg-5 col-md-12" v-if="activeTab == 'subTasks'">
                    <div class="card">
                        <div class="card-body">
                            <div class="filter-section mt-3">
                                <div class="d-flex align-items-center mb-3">
                                    <div>
                                        <button type="button" class="btn btn-dark create-subtask-button"
                                            @click.prevent="createSubtask">
                                            Create Subtask
                                        </button>
                                    </div>
                                    <div>
                                        <input id="main-search-input" type="search" class="form-control"
                                            placeholder="Search..." aria-label="search"
                                            aria-describedby="addon-wrapping" />
                                    </div>
                                </div>

                                <!-- Status Tabs -->
                                <ul class="nav nav-tabs tab-body-header rounded w-100 mb-2" role="tablist">
                                    <li class="nav-item">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '0' || filters.statusId == undefined,
                                            'nav-link text-center': filters.statusId != '0' && filters.statusId != undefined,
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '0', page: 1 })"
                                            href="#" role="tab">
                                            All
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '1',
                                            'nav-link text-center': filters.statusId != '1',
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '1', page: 1 })"
                                            href="#" role="tab">
                                            On Hold
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '2',
                                            'nav-link text-center': filters.statusId != '2',
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '2', page: 1 })"
                                            href="#" role="tab">
                                            In Progress
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '3',
                                            'nav-link text-center': filters.statusId != '3',
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '3', page: 1 })"
                                            href="#" role="tab">
                                            Done
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '4',
                                            'nav-link text-center': filters.statusId != '4',
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '4', page: 1 })"
                                            href="#" role="tab">
                                            Archived
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '5',
                                            'nav-link text-center': filters.statusId != '5',
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '5', page: 1 })"
                                            href="#" role="tab">
                                            On Going
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <!-- Date Filters -->
                            <div class="mb-3 d-flex align-items-center">
                                <label for="start-date" class="form-label me-2">Start date:</label>
                                <input type="date" id="start-date" v-model="startDate" class="form-control w-auto" />
                            </div>

                            <div class="mb-3 d-flex align-items-center">
                                <label for="end-date" class="form-label me-2">End date:</label>
                                <input type="date" id="end-date" v-model="endDate" class="form-control w-auto" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Create SubTask -->
    <div class="modal fade" id="create-subtask-form" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title fw-bold">Edit SubTask</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <input type="hidden" name="projectId" v-model="subTaskData.projectId">
                <div class="modal-body">
                    <!-- SubTask Data Form -->
                    <div class="mb-3">
                        <label class="form-label">Title</label>
                        <input type="text" class="form-control" placeholder="Title" name="title"
                            v-model="subTaskData.title">
                    </div>
                    <div class="mb-3" v-if="(subTaskData && subTaskData.createdBy == currentUserInfo?.id) || superUser">
                        <label for="subTaskDescriptionTinyMce" class="form-label">Creator's brief<sup>*</sup></label>
                        <Editor api-key="no-api-key" :init="tinymceInit" v-model="subTaskData.body"></Editor>
                    </div>
                    <div class="mb-3" v-if="(subTaskData && subTaskData.managerId == currentUserInfo?.id) || superUser">
                        <label for="subTaskManagerBriefTinyMce" class="form-label">Manager's brief</label>
                        <Editor api-key="no-api-key" :init="tinymceInit" v-model="subTaskData.manager_brief"></Editor>
                    </div>
                    <div class="mb-3" v-if="superUser || canEditSubTaskCreator">
                        <label class="form-label">Creator</label>
                        <Select2 :options="allData.users" v-model="subTaskData.createdBy"
                            :settings="select2SettingsProject" />
                    </div>
                    <div class="mb-3">
                        <label class="form-label">Status<sup>*</sup></label>
                        <Select2 :options="allData.statuses" v-model="subTaskData.statusId"
                            :settings="select2SettingsSubTask" />
                    </div>
                    <div class="mb-3">
                        <label class="form-label">Manager<sup>*</sup></label>
                        <Select2 :options="allData.users" v-model="subTaskData.managerId"
                            :settings="select2SettingsSubTask" />
                    </div>
                    <div class="mb-3">
                        <label class="form-label">Assigned users</label>
                        <Select2 :options="allData.users" v-model="subTaskData.assignedUsers"
                            :settings="{ ...select2SettingsSubTask, multiple: true }" />
                    </div>
                    <div class="deadline-form">
                        <form>
                            <div class="row g-3 mb-3">
                                <div class="col">
                                    <label for="subTaskStartDate" class="form-label">Start Date<sup>*</sup></label>
                                    <input type="date" class="form-control" name="startDate"
                                        v-model="subTaskData.startDate">
                                </div>
                                <div class="col">
                                    <label for="subTaskEndDate" class="form-label">End Date<sup>*</sup></label>
                                    <input type="date" class="form-control" name="endDate"
                                        v-model="subTaskData.endDate">
                                </div>
                            </div>
                        </form>
                    </div>
                    <div id="create-project-errors"></div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click.prevent="submitSubTaskForm">Update</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="unsavedChangesModal" tabindex="-1" aria-labelledby="unsavedChangesLabel"
        aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="unsavedChangesLabel">Unsaved Changes</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    You may have unsaved changes. Are you sure you want to leave this page?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-sm btn-danger text-white" @click="confirmLeave">Leave</button>
                </div>
            </div>
        </div>
    </div>


    <div class="modal fade" id="archiveConfirmationModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title fw-bold">Confirm Archive</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p>Are you sure you want to archive this subtask?</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-danger" @click="confirmArchive">Yes, Archive</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { initials, daysLeft, editorSkin } from '@/wxHelpers';
import { statusStyle } from '@/status';
import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue';
import { useFetchData } from '@/composables/useFetchData';
import { getClientsServicesStatusesUsers, createComment } from '@/services/subtasks';
import { fetchAll } from '@/services/subtasks';
import { get as getTask, searchUsers } from '@/services/tasks';
import { get as getSubtask } from '@/services/subtasks';
import { createOrUpdate as createOrUpdateSubtask, createFolder as createSubTaskFolder, massArchiveSubTasks, updateInfo, updateManager, updateGeneral } from '@/services/subtasks';
import { createOrUpdate as createOrUpdateTask } from '@/services/tasks';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';
import Editor from '@tinymce/tinymce-vue';
import Select2 from 'vue3-select2-component';
import { mapGetters } from 'vuex';
import { fetchUserInfo } from '@/services/user';
import { all } from 'axios';
import { updateTaskStatus } from '@/services/todo';
import { updateSubtaskStatus } from '@/services/followup';

export default {
    name: 'Task',
    components: {
        Editor,
        Select2,
    },
    data() {
        return {
            showUnsavedModal: false,
            isEditingInfo: false,
            isEditingGeneral: false,
            isEditingManagersBrief: false,
            pendingNavigation: null, // Store pending navigation details
        };
    },
    methods: {
        initials,
        daysLeft,
       
        confirmLeave() {
            this.resetEditingStates();
            if (this.pendingNavigation) {
                this.pendingNavigation();
                this.pendingNavigation = null;
            }
            const modal = $('#unsavedChangesModal');
            modal.modal('hide');
        },
      

        scrollToBottom() {
            // Scroll the chat container to the bottom
            const chatHistory = this.$refs.chatHistory;
            if (chatHistory) {
                chatHistory.scrollTop = chatHistory.scrollHeight;
            }
        },
        parseLinks(text) {
    if (!text) return '';

    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function(url) {
      return `<a href="${url}" target="_blank" class="link_url underline">${url}</a>`;
    });
  },
        resetEditingStates() {
            this.isEditingInfo = false;
            this.isEditingManagersBrief = false;
            this.isEditingGeneral = false;
        },
        canEditSubtask(subtask) {
            if (!subtask) {
                return false;
            }
            return (
                localStorage.getItem('current_user_id') == subtask.info?.createdBy &&
                this.userPermissionsSubTasks?.edit === 1
            );
        },
       
        editSubTask() {
            this.isEditingInfo = true;
        },
        editSubTaskManager() {
            this.isEditingManagersBrief = true;
        },

        cancelEditing() {
            this.isEditingInfo = false;

        },
        cancelEditingManager() {
            this.isEditingManagersBrief = false;

        },
        async saveInfo() {
            try {
                // Prepare the payload with both `id` and `body`
                const payload = {
                    id: this.$route.params.id, // ID from route parameters
                    body: this.subTaskViewData.info.body // Editor content
                };

                const toast = useToast();


                // Call the updateInfo service with the correct payload
                const response = await updateInfo(this.subTaskViewData.info);

                if(response.data.success){
 // Show success message
 toast.success(response.data.message);
// Exit editing mode
                this.isEditingInfo = false;
                }else{
                    toast.error(response.data.message);

                }
               
                
            } catch (error) {
                // Handle any errors that occur during the API call
                console.error('Error updating information:', error);
            }
        },

        async saveManager() {
            try {
                // Prepare the payload with both `id` and `body`
                const payload = {
                    id: this.$route.params.id, // ID from route parameters
                    manager_brief: this.subTaskViewData.info.manager_brief // Editor content
                };

                const toast = useToast();


                // Call the updateInfo service with the correct payload
                const response = await updateManager(this.subTaskViewData.info);

                // Show success message
                if(response.data.success){
 // Show success message
 toast.success(response.data.message);

                }else{
                    toast.error(response.data.message);

                }
                // Exit editing mode
                this.isEditingManagersBrief = false;
            } catch (error) {
                // Handle any errors that occur during the API call
                console.error('Error updating information:', error);
            }
        },
    },
    watch: {
 

  // Existing watcher for comments (keep this as is)
  'subTaskViewData.comments'(newComments, oldComments) {
    this.$nextTick(() => {
      this.scrollToBottom();
    });
  }
},

    updated() {
        // Ensure the view scrolls to the bottom after every update
        if (this.activeTab === 'subTaskChat') {
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        }
    },
    mounted() {
        // Scroll to the bottom when the component is first loaded
        this.$nextTick(() => {
            this.scrollToBottom();
        });

    },
    computed: {
        ...mapGetters({
            getUserPermission: 'getUserPermission',
            getSuperUserPermission: 'getSuperUserPermission'
        }),
        userPermissionsSubTasks() {
            return this.getUserPermission('Subtasks');
        },
        canCreate() {
            return this.userPermissionsTasks?.create === 1;
        },
        canUpdate() {
            return this.userPermissionsTasks?.create === 1;
        },
        canArchive() {
            return this.userPermissionsSubTasks?.archive === 1;
        },
        userPermissionsTasks() {
            return this.getUserPermission('Tasks');
        },
        canEditSubTaskCreator() {
            return this.userPermissionsSubTasks?.editCreator === 1;
        },
        canEditTask() {
            return this.userPermissionsTasks?.edit === 1;
        },
        canEditAllTasks() {
            return this.userPermissionsTasks?.editAll === 1;
        },
        canEditAllSubtasks() {
            return this.userPermissionsSubTasks?.editAll === 1;
        },
        superUser() {
            return this.getSuperUserPermission === 1;
        },
        getUser() {
            return this.$store.state.userInfo.id;
        },
        currentUserId() {
            return localStorage.getItem('current_user_id'); // Safely retrieve the ID once
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.isEditingInfo || this.isEditingManagersBrief || this.isEditingGeneral) {
            this.pendingNavigation = next;
            const modal = $('#unsavedChangesModal');
            modal.modal('show');
        } else {
            next();
        }
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const toast = useToast();
        const activeTab = ref(route.query.activeTab || 'info');
        const newComment = ref('');
        const startDate = ref('');
        const endDate = ref('');
        const showAutocomplete = ref(false);
        const subtaskIdToArchive = ref(null); // Store the ID of the task to archive
        const users = ref([]);
        const subTaskViewData = ref(null);
        const isEditingGeneral = ref(false); // Ensure this is defined as a ref
        const managerSelectSubTask = ref(null);
        const assignedUsersSelectSubTask = ref(null);

        const openArchiveConfirmation = (subtaskId) => {
            subtaskIdToArchive.value = subtaskId;
            $('#archiveConfirmationModal').modal('show'); // Show the confirmation modal
        };

        const confirmArchive = async () => {
            if (!subtaskIdToArchive.value) return;

            try {
                const response = await massArchiveSubTasks({ ids: [subtaskIdToArchive.value] });
                if (response.data.success) {
                    useToast().success('Subtask archived successfully');
                    fetchData(); // Refresh the subtasks list
                } else {
                    useToast().error('Failed to archive subtask');
                }
            } catch (error) {
                useToast().error('An error occurred while archiving');
            } finally {
                $('#archiveConfirmationModal').modal('hide'); // Close the modal
                subtaskIdToArchive.value = null;
            }
        };

        const fetchSubtaskData = async (id = route.query.id) => {
  if (!id) return;
  try {
    const response = await getSubtask({ id });
    subTaskViewData.value = response.data;
  } catch (error) {
    console.error('Failed to load subtask:', error);
  }
};


        const filterUsernames = () => {
            const input = newComment.value;
            const match = input.match(/@(\w*)$/); // Match @username pattern

            if (match) {
                const searchTerm = match[0].substring(1); // Extract text after '@'

                // Call the filtering logic only if there are at least 2 characters after "@"
                if (searchTerm.length >= 2) {

                    const query = match[1].toLowerCase();
                    filteredUsernames.value = users.value.filter(user =>
                        user.username.toLowerCase().includes(query)
                    );
                    showAutocomplete.value = filteredUsernames.value.length > 0;
                } else {
                    showAutocomplete.value = false;
                }
            } else {
                showAutocomplete.value = false;
            }
        };

     

        const subTaskData = ref({
            id: '',
            taskId: '0',
            title: '',
            description: '',
            assignedUsers: [],
            managerId: '',
            statusId: '',
            startDate: '',
            endDate: ''
        });

        const allData = ref({});
        const taskViewData = ref(null);
        const selectedSubTaskIds = ref([]);
        const isDropdownOpen = ref(false);
        const filteredUsernames = ref([]);
        const currentUserInfo = ref(null);

        const { data, paginationLinks, filters, updateFilters, fetchData, sortBy } = useFetchData(fetchAll, { id: route.query.id, page: route.query.page || 1, archived: route.query.archived || 0, statusId: route.query.statusId || 2 }, { id: route.query.id, page: 1, archived: 0, statusId: 2 });

        const toggleSubTaskSelection = (subTaskId) => {
            if (!selectedSubTaskIds.value.includes(subTaskId)) {
                selectedSubTaskIds.value.push(subTaskId);
            } else {
                selectedSubTaskIds.value = selectedSubTaskIds.value.filter(id => id !== subTaskId);
            }
        };

        const createFolder = async (id) => {
            const r = await createSubTaskFolder(id);
            if (r.data.success) {
                toast.success(r.data.message);
                subTaskViewData.value = (await getSubtask({ id: route.query.id })).data.data;
            } else {
                toast.error(r.data.message)
            }
        };

        const createSubtask = async () => {
            const tmpAllData = await getClientsServicesStatusesUsers({ params: { type: "subtasks", entityId:route.query.id } });
            let newData = { users: [], statuses: [], clients: [], services: [] };
            for (let i = 0; i < tmpAllData.data.users.length; i++) {
                newData.users.push({ id: tmpAllData.data.users[i].id, text: tmpAllData.data.users[i].username });
            }
            for (let i = 0; i < tmpAllData.data.statuses.length; i++) {
                newData.statuses.push({ id: tmpAllData.data.statuses[i].id, text: tmpAllData.data.statuses[i].description });
            }
            for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
            }
            for (let i = 0; i < tmpAllData.data.services.length; i++) {
                newData.services.push({ id: tmpAllData.data.services[i].id, text: tmpAllData.data.services[i].title });
            }
            allData.value = newData;
            subTaskData.value = {
                taskId: route.query.id || 0,
                title: '',
                manager_brief: '',
                body: '',
                assignedUsers: [],
                managerId: '',
                statusId: '0',
                totalHours: '',
                startDate: '',
                endDate: ''
            };
            $("#create-subtask-form").modal('toggle');
        };



        const submitComment = async () => {
            const response = await createComment({ "id": route.query?.id, comment: newComment.value });
            if (response.data.success) {
                newComment.value = '';
                subTaskViewData.value = (await getSubtask({ id: route.query?.id })).data.data;
                $(".chat-history").animate({ scrollTop: $(".chat-history")[0].scrollHeight }, 1000);
                toast.success(response.data.message);
            } else {
                toast.error(response.data.message);
            }
        };



        const saveGeneral = async () => {
            const response = await updateGeneral(subTaskData.value);
            response.data.success ? toast.success(response.data.message) : toast.error(response.data.message);
            subTaskViewData.value = (await getSubtask({ id: route.query.id })).data.data;
            fetchData();
            response.data.success ? isEditingGeneral.value = false : isEditingGeneral.value = true;
        };

        const dropdownStyle = computed(() => ({
            top: isDropdownOpen.value ? '100%' : 'initial',
            right: isDropdownOpen.value ? '0' : 'initial'
        }));

        const toggleDropdown = () => {
            isDropdownOpen.value = !isDropdownOpen.value;
        };

        const closeDropdown = () => {
            isDropdownOpen.value = false;
        };
        const setActiveTab = (tab) => {
  activeTab.value = tab
  router.replace({ query: { ...route.query, activeTab: tab } })
};
        const getStatusStyle = (id) => statusStyle(id, 'min-width:9em; height:2.5em;');

        const tinymceInit = {
            height: 300,
            license_key: 'gpl',
            ...editorSkin(),
            plugins: 'link autolink',
            toolbar: 'undo redo | bold italic underline | link',
        };

        const select2SettingsTask = {
            dropdownParent: '#create-task-form .modal-content',
            placeholder: "Please select"
        };

        const selectUsername = (username) => {
            newComment.value = newComment.value.replace(/@(\w*)$/, `@${username} `);
            filteredUsernames.value = [];
            showAutocomplete.value = false;
        };

        const selectStatus = async (taskId, statusId) => {
            const r = await updateSubtaskStatus(taskId, statusId);
            if (r.data.success) {
                useToast().success(r.data.message);
                subTaskViewData.value = (await getSubtask({ id: route.query.id })).data.data;
                fetchData();
            } else {
                useToast().error(r.data.message);
            }
        };

        const statuses = ref([]);

        const editSubTaskGeneral = async () => {
            try {
                const tmpAllData = await getClientsServicesStatusesUsers({ params: { type: "subtasks", entityId:route.query.id } });
                let newData = { users: [], statuses: [], clients: [], services: [] };

                for (let i = 0; i < tmpAllData.data.users.length; i++) {
                    newData.users.push({ id: tmpAllData.data.users[i].id, text: tmpAllData.data.users[i].username });
                }
                for (let i = 0; i < tmpAllData.data.statuses.length; i++) {
                    newData.statuses.push({ id: tmpAllData.data.statuses[i].id, text: tmpAllData.data.statuses[i].description });
                }
                for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                    newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
                }
                for (let i = 0; i < tmpAllData.data.services.length; i++) {
                    newData.services.push({ id: tmpAllData.data.services[i].id, text: tmpAllData.data.services[i].title });
                }

                allData.value = newData; // `allData` is a ref, so use `.value`

                const subTaskInfo = await getSubtask({ id: route.query.id });
                let subtaskDataValue = subTaskInfo.data.data.info;
                subtaskDataValue.managerId = subTaskInfo.data.data.manager?.id;
                subtaskDataValue.statusId = subTaskInfo.data.data.status?.id;
                subtaskDataValue.assignedUsers = subTaskInfo.data.data.assigned?.map((u) => u.id);
                subtaskDataValue.projectId = subTaskInfo.data.data.project?.id;

                subTaskData.value = subtaskDataValue; // `subTaskData` is a ref, so use `.value`

            } catch (error) {
                console.error('Error in editSubTaskGeneral:', error);
            }

            isEditingGeneral.value = true; // Use `.value` for reactive refs
        };

        const cancelEditingGeneral = async () => {
            isEditingGeneral.value = false;

        };


        const getStatusIcon = (id) => {
            const status = statuses.value.find((s) => s.id === id);
            return status ? status.icon : "";
        };

        const getCurrentStatus = (id) => {
            const status = statuses.value.find((s) => s.id === id);
            return status ? status.description : "Select Status";
        };

        const searchAction = () => {
            setTimeout(() => {
                router.push({ path: '/task', query: { ...route.query, search: $("#main-search-input").val() } });
            }, 300);
        };

        const getPageFromUrl = (url) => {
            if (!url) return null;
            const urlObj = new URL(url, window.location.origin);
            return urlObj.searchParams.get('page');
        };

        const handleClickOutside = (event) => {
            const dropdown = document.querySelector('.autocomplete-dropdown');
            const textarea = document.getElementById('commentTextarea');

            if (
                (dropdown && !dropdown.contains(event.target)) &&
                (!textarea || !textarea.contains(event.target))
            ) {
                showAutocomplete.value = false;
            }
        };

         const filteredUsersForManagerSubTask = computed(() => {
  return allData.value.users?.filter(user =>
    !subTaskData.value.assignedUsers.includes(String(user.id))
  ) || [];
});

const filteredUsersForAssignedSubTask = computed(() => {
  return allData.value.users?.filter(user =>
    String(user.id) !== subTaskData.value.managerId
  ) || [];
});

watch(() => subTaskData.value.managerId, (newManagerId) => {
    if (subTaskData.value.assignedUsers.includes(newManagerId)) {
        subTaskData.value.assignedUsers = subTaskData.value.assignedUsers.filter(id => id !== newManagerId);
    }

    // Force re-render of assigned users select
    nextTick(() => {
        assignedUsersSelectSubTask.value?.$forceUpdate?.();
    });
});

watch(() => subTaskData.value.assignedUsers, (newAssigned) => {
    if (newAssigned.includes(subTaskData.value.managerId)) {
        subTaskData.value.managerId = '';
    }

    // Force re-render of manager select
    nextTick(() => {
        managerSelectSubTask.value?.$forceUpdate?.();
    });
});


        onMounted(async () => {
            const allRequiredData = await getClientsServicesStatusesUsers({ params: { type: "subtasks", entityId:route.query.id } });
            statuses.value = allRequiredData.data.statuses;
            users.value = allRequiredData.data.users;
            currentUserInfo.value = (await fetchUserInfo()).data.info;
            $(document.body).on('keyup', "#main-search-input", searchAction).on('click', "#main-search-input", searchAction);
            subTaskViewData.value = (await getSubtask({ id: route.query.id })).data.data;
            document.addEventListener('click', handleClickOutside);

        });

        onUnmounted(() => {
            $(document.body).off('keyup', "#main-search-input", searchAction).off('click', "#main-search-input", searchAction);
            document.removeEventListener('click', handleClickOutside);

        });

        const updateSubtaskStatusId = async (subtaskId, statusId) => {
            const r = await updateSubtaskStatus(subtaskId, statusId);
            if (r.data.success) {
                useToast().success(r.data.message);
                subTaskViewData.value = (await getSubtask({ id: route.query.id })).data.data;
                fetchData();
            } else {
                useToast().error(r.data.message);
            }
        };
        

        return {
            createFolder,
            currentUserInfo,
            showAutocomplete,
            selectUsername,
            filterUsernames,
            filteredUsernames,
            confirmArchive,
            openArchiveConfirmation,
            startDate,
            endDate,
            newComment,
            updateSubtaskStatusId,
            fetchSubtaskData,
            createSubtask,
            selectStatus,
            data,
            filters,
            updateFilters,
            paginationLinks,
            activeTab,
            route,
            getPageFromUrl,
            statuses,
            getStatusIcon,
            getCurrentStatus,
            searchAction,
            allData,
            subTaskData,
            subTaskViewData,
            selectedSubTaskIds,
            toggleDropdown,
            closeDropdown,
            isDropdownOpen,
            dropdownStyle,
            tinymceInit,
            select2SettingsTask,
            submitComment,
            filteredUsernames,
            selectUsername,
            getStatusStyle,
            editSubTaskGeneral,
            isEditingGeneral,
            cancelEditingGeneral,
            saveGeneral,
            setActiveTab, filteredUsersForManagerSubTask, filteredUsersForAssignedSubTask
        };
    },
};
</script>

<style scoped>
.chat-message {
    color: black !important;
}

.project-code {
    font-size: 1.5rem;
    font-weight: bold;
}

.status-dropdown {
    position: relative;
    display: inline-block;
}

.status-button {
    background-color: #f1f1f1;
    color: #333;
    padding: 8px 16px;
    font-size: 1rem;
    font-weight: bold;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
    border-radius: 8px;

}

.status-button {
    background-color: transparent;
    color: #333;
    font-size: 1rem;
    font-weight: bold;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 3px;
    border-radius: 8px;

}

.status-dropdown:hover .status-dropdown-content {
    display: flex;
}

.status-dropdown:hover .status-dropdown-content-tasks {
    display: flex;
    flex-direction: row;
    right: 0;
}

.status-dropdown-content-tasks {
    z-index: 9000;
    position: absolute;
    background-color: white;
    min-width: fit-content;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    display: none;
    flex-direction: column;
}

.status-dropdown-content {
    z-index: 9000;
    position: absolute;
    background-color: white;
    min-width: fit-content;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.3);
    padding: 8px;
    border-radius: 8px;
    display: none;
    flex-direction: column;
    gap: 10px;
}

.status-dropdown>button {
    height: 1.5em;
}

.status-dropdown-content button {
    width: 100%;
    background: none;
    border: none;
    padding: 10px;
    text-align: left;
    font-size: 0.9rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
}

.status-dropdown-content-tasks button {
    width: 100%;
    background: none;
    border: none;
    padding: 10px;
    text-align: left;
    font-size: 0.8rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.status-dropdown-content-tasks button:hover {
    transform: scale(1.6);
    transition: .5s;
}

.status-dropdown-content button:hover {
    background-color: lightgray;
}

.active-status {
    font-weight: bold;
    background-color: #007bff;
    color: white;
    border-radius: 5px;
}

.create-task-button {
    width: 100%;
}


.nav-tabs {
    border: none;
}

/* Style for all list items to have a bottom border */
.nav-tabs .nav-item {
    border-bottom: 1px solid #DCDCDC;
    /* Light gray border for non-active items */
    /* margin-left:20px; */
}

.nav-tabs .nav-item .nav-link {
    color: #8C8C8C;
}

/* Style for the active tab to have a darker bottom border */
.nav-tabs .nav-item .nav-link.active,
.nav-tabs .nav-item .nav-link:hover {
    border-color: white;

    border-bottom: 3px solid #8C8C8C;
    /* Darker gray border for the active tab */
    color: black;

}

/* Optionally, you can remove the bottom border for non-active tabs on hover to make the UI clearer */

/* Add this CSS to ensure the button is placed on the right border */
.col-xl-8.col-lg-7.col-md-12 {
    position: relative;
    /* Make the parent div relative */
}

/* Style the button to be positioned absolutely at the border-right */
.status-button-wrapper {
    position: absolute;
    /* Position it absolutely within the parent */
    top: 50px;
    /* Vertically center the button */
    right: -25px;
    /* Position it slightly outside to touch the border-right */
    transform: translateY(-50%);
    /* Adjust for exact vertical centering */
    z-index: 10;
    /* Ensure the button stays above other elements */
}

.autocomplete-dropdown {
    position: absolute;
    z-index: 1000;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    max-height: 200px;
    /* Limit height */
    overflow-y: auto;
}

.autocomplete-dropdown ul {
    padding: 0;
    margin-top: 110px;
}

.autocomplete-item {
    padding: 8px 12px;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.autocomplete-item:hover {
    background-color: #f0f0f0;
    color: #333;
}

textarea {
    resize: none;
    overflow: auto;
}

textarea:focus {
    border-color: #007bff;
    outline: none;
    box-shadow: 0 0 4px rgba(0, 123, 255, 0.25);
}

/* .sendComment {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
} */

#commentTextarea {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}

.nav-tabs.tab-body-header .nav-link.active span {
    color: white;
}

#projectTableMobile {
    display: none !important;
}

.mobilefilters {
    display: none;
}

.dropdown-btn-filter {
    cursor: pointer;
    text-transform: capitalize;
    font-weight: 600;
    color: #545454;
}

.dropdown-btn {
    cursor: pointer;
}

/* Dropdown Options List */
.dropdown-options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    border: 1px solid #dedede;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    z-index: 100;
    max-height: 200px;
    overflow-y: auto;
    width: 100%;
    list-style: none;
    padding: 0;
    margin: 0;
    min-width: 200px;
}

.dropdown-options-filters {
    position: absolute;
    border: 1px solid #dedede;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    z-index: 100;
    max-height: 200px;
    overflow-y: auto;
    width: fit-content;
    list-style: none;
    padding: 0;
    margin: 0;
    min-width: 200px;
}

.dropdown-options li,
.dropdown-options-filters li {
    padding: 10px 15px;
    cursor: pointer;
    font-size: 14px;
    color: #545454;
    font-weight: 600;
    border-bottom: 1px dashed lightgray;
}

.dropdown-options li:hover,
.dropdown-options-filters li:hover {
    background-color: #545454;
    color: white;
}

.dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 90px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    width: 100%;
    /* Ensure the container is wide enough */
}

.dropdown-container:hover .dropdown-content {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: fit-content;
    padding: 8px 4px;
    border: 1px solid lightgray;
    z-index:2;
}

.dropdown-content button {
    display: block;
    /* Make buttons stack vertically */
    width: 100%;
    /* Make buttons take the full width of the container */
    margin: 0;
    /* Remove margin to avoid spacing issues */
    box-sizing: border-box;
    /* Ensure padding does not affect width */
    margin-bottom: 3px;

}
.flex-column-desk{
    flex-direction: column;
}
::v-deep(.select2-container--default .select2-selection--multiple) {
    border: 0px
}
::v-deep(.select2-container--default .select2-selection--single .select2-selection__rendered){
    border: 0px solid var(--border-color);
}
@media screen and (max-width: 1279px) {
    .tagInfo {
        display: none !important;
    }

    .rightborderSec {
        border-right: 0px !important;
    }

    .status-button-wrapper {
        top: -10px;
        right: 15px;
        transform: translateY(-100%);
    }

    .editing-actions {
        flex-direction: row;
        align-items: baseline;
    }

    .justifyContentbetmob {
        justify-content: space-between;
    }

    .savebutton {
        width: 25px !important;
    }

    .cancelbutton {
        width: 25px !important;
    }

    .editbutton {
        width: 25px !important;
    }

    .tab-content {
        border-bottom: 1px solid lightgray;
    }

    .belowEditbtn {
        top: -35px !important;
    }

    .dateprojectdiv {
        display: flex;
        align-items: center;
    }

    .dateprojectdiv img {
        width: 20px !important;
    }

    .dateprojectdiv span {
        font-size: 13px !important;
    }

    .authorsChatDiv {
        width: 85% !important;
    }

    #commentTextarea {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }

    #projectTableMobile {
        display: flex !important;
    }

    .mobileRows {
        /* padding: 5px 10px; */
        border-bottom: 1px dashed #dedede;
        margin-bottom: 12px;
    }

    #myProjectTable {
        display: none;
    }

    .rightCol {
        padding-left: calc(var(--bs-gutter-x) * .5);
    }

    .mobilefilters {
        display: unset;
    }

    .desktopfilters {
        display: none;
    }
    .d-flex-mob{
        display: flex;
    }
    .pipe-separator{
        display:none
    }
    .breadcrumb-mob{
        display: none !important;
    }
    .project-code {
        font-size: 1.25rem;
    }
    .flex-column-desk{
        flex-direction: unset;
    }

    body.modal-open {
        overflow: hidden !important;
        position: fixed;
        width: 100%;
        touch-action: none;

    }

    /* CRITICAL: TinyMCE dialogs must appear ABOVE Bootstrap modals */
    .tox-tinymce-aux,
    .tox-dialog-wrap,
    .tox-dialog,
    .tox-dialog__backdrop {
        z-index: 99999 !important;
    }
    /* Ensure Bootstrap modals stay below TinyMCE dialogs */
    .modal {
        z-index: 1050 !important;
    }

    .modal-backdrop {
        z-index: 1040 !important;
    }
}
</style>
